"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAngleUpdater = void 0;
const AngleUpdater_1 = require("./AngleUpdater");
function loadAngleUpdater(tsParticles) {
    tsParticles.addParticleUpdater("angle", () => new AngleUpdater_1.AngleUpdater());
}
exports.loadAngleUpdater = loadAngleUpdater;
